import Upload from "antd/lib/upload";

export default Upload;
